var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3402_4613)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.4762,
    cy: 11.2381,
    r: 10.5,
    fill: "white",
    stroke: "#FD8238"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49167 13.9257C7.18691 13.9257 6.9031 13.8705 6.64024 13.76C6.37739 13.6495 6.14691 13.4952 5.94882 13.2971C5.75072 13.0991 5.59643 12.8667 5.48596 12.6C5.37548 12.3333 5.32024 12.0419 5.32024 11.7257C5.32024 11.4095 5.37358 11.1181 5.48024 10.8514C5.58691 10.581 5.73739 10.3486 5.93167 10.1543C6.12596 9.95619 6.35262 9.80381 6.61167 9.69715C6.87453 9.58667 7.16024 9.53143 7.46882 9.53143C7.77739 9.53143 8.05358 9.58286 8.29739 9.68572C8.54501 9.78858 8.75453 9.92572 8.92596 10.0971C9.09739 10.2686 9.21929 10.4591 9.29167 10.6686L8.50882 11.0457C8.43643 10.84 8.30882 10.6705 8.12596 10.5371C7.94691 10.4 7.72786 10.3314 7.46882 10.3314C7.21739 10.3314 6.99643 10.3905 6.80596 10.5086C6.61548 10.6267 6.46691 10.7905 6.36024 11C6.25739 11.2057 6.20596 11.4476 6.20596 11.7257C6.20596 12.0038 6.2612 12.2476 6.37167 12.4571C6.48215 12.6667 6.63262 12.8305 6.8231 12.9486C7.01739 13.0667 7.24024 13.1257 7.49167 13.1257C7.68596 13.1257 7.86691 13.0895 8.03453 13.0171C8.20596 12.941 8.3431 12.8324 8.44596 12.6914C8.55262 12.5505 8.60596 12.381 8.60596 12.1829V11.8286L9.01167 12.1714H7.46882V11.4286H9.49167V11.88C9.49167 12.2267 9.43453 12.5295 9.32024 12.7886C9.20596 13.0438 9.05167 13.2571 8.85739 13.4286C8.66691 13.5962 8.45167 13.7219 8.21167 13.8057C7.97548 13.8857 7.73548 13.9257 7.49167 13.9257ZM10.0386 13.8571V9.6H10.8957L12.49 11.7143H12.09L13.6386 9.6H14.4957V13.8571H13.61V10.5771L13.9643 10.6571L12.3243 12.7714H12.21L10.6272 10.6571L10.9243 10.5771V13.8571H10.0386ZM16.0164 13.8571V10.3714H14.9364V9.6H17.9649V10.3714H16.9021V13.8571H16.0164Z",
    fill: "#FD8238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3402_4613",
    x: 1.19209e-7,
    y: 0.00000292063,
    width: 22.9524,
    height: 22.9524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.238095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.238095
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3402_4613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3402_4613",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmtLogo);
export default __webpack_public_path__ + "static/media/gmt-logo.a616a49d1117de737bfab164acf85606.svg";
export { ForwardRef as ReactComponent };